var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.73333 8.30524V7.59992C5.73333 5.24351 7.64359 3.33325 10 3.33325C12.3564 3.33325 14.2667 5.2435 14.2667 7.59992V8.30524C14.2667 9.83879 14.7099 11.3397 15.5431 12.6272L16 13.3333H4L4.45693 12.6271C5.29008 11.3397 5.73333 9.83879 5.73333 8.30524Z",
    stroke: "black",
    strokeOpacity: 0.95,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33301 15.926C9.68927 16.3219 10.3101 16.3219 10.6663 15.926",
    stroke: "black",
    strokeOpacity: 0.95,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.c7f06c445cb9b1553ce0f55edb6dc58c.svg";
export { ForwardRef as ReactComponent };